<template>
  <va-modal
    :value="isOpen"
    ref="editPasswordModal"
    :okText="$t('modal.confirm')"
    :cancelText="$t('modal.cancel')"
    @cancel="cancelUpdateUserPassword"
    @ok="updateUserPassword"
    :okDisabled="submitDisabled"
    :no-outside-dismiss="true">

    <div slot="header" class="d-flex justify--space-between">
      <span class="modal-title">{{ $t('users.inputs.change_password')}}</span>
    </div>

    <section class="evollu-form">
        <div class="form-row col-12">
          <va-input
            v-model="oldPassword"
            id="old-password-input"
            type="password"
            :label="$t('profile.old_password')"
            :placeholder="$t('profile.old_password')"
            @input="validationErrors.clear('password')"
            :error="validationErrors.has('password')"
            :error-messages="[$t(validationErrors.get('password'))]"
          />
        </div>

        <div class="form-row col-12">
          <va-input
            v-model="newPassword"
            id="password-input"
            type="password"
            :label="$t('users.inputs.new_password')"
            :placeholder="$t('users.inputs.new_password')"
            @input="validationErrors.clear('new_password')"
            :error="invalidPassword"
            :error-messages="[$t('users.inputs.invalid_password')]"
          />
        </div>

        <div class="form-row col-12">
          <va-input
            v-model="newPasswordConfirmation"
            id="password-confirm-input"
            type="password"
            :label="$t('users.inputs.confirm_password')"
            :placeholder="$t('users.inputs.confirm_password')"
            @input="validationErrors.clear('new_password')"
            :error="nonMatchingPassword"
            :error-messages="[$t('users.inputs.different_password')]"
          />
        </div>
        <div class="form-row col-12" style="background: rgba(199,104,104,0.7); border-radius: 10px" v-if="validationErrors.has('new_password')">
          <label class="is-bold" style="color: #9b0909"> {{$t(validationErrors.get('new_password'))}} </label>
        </div>
    </section>
  </va-modal>
</template>
<script>
import Errors from '@/utils/CustomNodeErrors'
import { PASSWORD_REGEX } from '@/utils/regex'
import { ProfileService } from '@/api/AuthService'
import store from "vuex-store";

export default {
  data () {
    return {
      isOpen: false,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      validationErrors: new Errors(),
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    updateUserPassword: function () {
      let data = {}
      data.password = this.oldPassword
      data.new_password = this.newPassword

      ProfileService.updatePassword(data)
        .then(response => {
          this.$emit('password-updated')
          this.store.commit('SET_SHOULD_SHOW_PASSWORD_RENEWAL_WARNING', false)
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.validationErrors.record(error.response.data.errors, 'server_auth.errors.')
            console.log(this.validationErrors)
          }
          this.showToast(this.$t('profile.toast.password_error'), this.$store.state.errorToastOptions)
        })
    },
    cancelUpdateUserPassword: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 250)
    }
  },
  computed: {
    store() {
      return store
    },
    submitDisabled: function () {
      if (this.newPassword === '' || this.oldPassword === '' || this.newPasswordConfirmation === '') {
        return true
      }
      return (this.invalidPassword || this.nonMatchingPassword)
    },
    invalidPassword: function () {
      if (this.newPassword) {
        return !this.newPassword.match(PASSWORD_REGEX)
      }
      return false
    },
    nonMatchingPassword: function () {
      if (this.newPassword && !this.invalidPassword && this.newPasswordConfirmation) {
        return this.newPassword !== this.newPasswordConfirmation
      }
      return false
    }
  }
}
</script>
